import React, { useEffect, useState, useContext } from "react";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Switch, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import useSettings from "../../hooks/useSettings";
import { ToastContainer, toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";

import { Tab, Tabs, TextField } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  tab: {
    backgroundColor: theme.mode === 'light' ? "#f2f2f2" : "#7f7f7f",
    borderRadius: 4,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }
  },
  toggleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    background: "#fafbfc",
    borderRadius: "8px",
    border: "1px solid #e8ecf1",
    marginBottom: "12px",
  },
  toggleLabel: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
    flex: 1,
  },
}));

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState("disabled");
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [expandedAccordion, setExpandedAccordion] = useState(false);

  const [UserRandom, setUserRandom] = useState("enabled");
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);

  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState("enabled");
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);

  //PAYMENT METHODS
  const [mpaccesstokenType, setmpaccesstokenType] = useState('');
  const [loadingmpaccesstokenType, setLoadingmpaccesstokenType] =
    useState(false);

  const [asaastokenType, setasaastokenType] = useState('');
  const [loadingasaastokenType, setLoadingasaastokenType] = useState(false);

  //OPENAI API KEY TRANSCRIÇÃO DE ÁUDIO
  const [openaitokenType, setopenaitokenType] = useState('');
  const [loadingopenaitokenType, setLoadingopenaitokenType] = useState(false);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  //LIMITAR DOWNLOAD
  // const [downloadLimit, setdownloadLimit] = useState("64");
  // const [loadingDownloadLimit, setLoadingdownloadLimit] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState("enabled")
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  // Fechar ticket ao transferir para outro setor
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false)
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false)

  // Status do ticket ao transferir com usuário
  const [transferredTicketStatus, setTransferredTicketStatus] = useState("open")
  const [loadingTransferredTicketStatus, setLoadingTransferredTicketStatus] = useState(false)

  // Usar carteira de clientes
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false)
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false)

  // Sigla para inserir no copiar contatos
  const [copyContactPrefix, setCopyContactPrefix] = useState("");
const [loadingCopyContactPrefix, setLoadingCopyContactPrefix] = useState(false);

  // WAVOIP Configuration
  const [wavoipUrl, setWavoipUrl] = useState("");
  const [loadingWavoipUrl, setLoadingWavoipUrl] = useState(false);

  const [wavoipUsername, setWavoipUsername] = useState("");
  const [loadingWavoipUsername, setLoadingWavoipUsername] = useState(false);

  const [wavoipPassword, setWavoipPassword] = useState("");
  const [loadingWavoipPassword, setLoadingWavoipPassword] = useState(false);

  //MENSAGENS CUSTOMIZADAS
  const [transferMessage, setTransferMessage] = useState("");
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);

  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);

  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);

  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);

  const [showNotificationPending, setShowNotificationPending] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);

  const [enableProfanityMonitor, setEnableProfanityMonitor] = useState("disabled");
  const [loadingEnableProfanityMonitor, setLoadingEnableProfanityMonitor] = useState(false);

  const { update: updateUserCreation, getAll } = useSettings();

  // const { update: updatedownloadLimit } = useSettings();

  const { update: updatempaccesstoken } = useSettings();
  const { update: updateasaastoken } = useSettings();

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };


  useEffect(() => {

    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value);
      }

      // const downloadLimit = oldSettings.find((s) => s.key === "downloadLimit");

      // if (downloadLimit) {
      //  setdownloadLimit(downloadLimit.value);
      // }

      const copyContactPrefix = oldSettings.find((s) => s.key === 'copyContactPrefix');
      if (copyContactPrefix) {
        setCopyContactPrefix(copyContactPrefix.value);
      }

      const mpaccesstokenType = oldSettings.find((s) => s.key === 'mpaccesstoken');
      if (mpaccesstokenType) {
        setmpaccesstokenType(mpaccesstokenType.value);
      }

      const asaastokenType = oldSettings.find((s) => s.key === 'asaastoken');
      if (asaastokenType) {
        setasaastokenType(asaastokenType.value);
      }

    }
  }, [oldSettings])


  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value)
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferredTicketStatus") setTransferredTicketStatus(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);
      if (key === "copyContactPrefix") setCopyContactPrefix(value);
      if (key === "wavoipUrl") setWavoipUrl(value || "");
      if (key === "wavoipUsername") setWavoipUsername(value || "");
      if (key === "wavoipPassword") setWavoipPassword(value || "");
      if (key === "enableProfanityMonitor") setEnableProfanityMonitor(value);
    }
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value,
    });
    setLoadingUserCreation(false);
  }

  // async function handleDownloadLimit(value) {
  //   setdownloadLimit(value);
  //   setLoadingdownloadLimit(true);
  //   await updatedownloadLimit({
  //     key: "downloadLimit",
  //     value,
  //   });
  //   setLoadingdownloadLimit(false);
  // }

  async function handleChangempaccesstoken(value) {
    setmpaccesstokenType(value);
    setLoadingmpaccesstokenType(true);
    await updatempaccesstoken({
      key: 'mpaccesstoken',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingmpaccesstokenType(false);
  }

  async function handleChangeasaastoken(value) {
    setasaastokenType(value);
    setLoadingasaastokenType(true);
    await updateasaastoken({
      key: 'asaastoken',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingasaastokenType(false);
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column: "userRating",
      data: value
    });
    setLoadingUserRating(false);
  }

  async function handleChangeEnableProfanityMonitor(value) {
    setEnableProfanityMonitor(value);
    setLoadingEnableProfanityMonitor(true);
    await update({
      column: "enableProfanityMonitor",
      data: value
    });
    setLoadingEnableProfanityMonitor(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column: "scheduleType",
      data: value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleCopyContactPrefix(value) {
    setCopyContactPrefix(value);
    setLoadingCopyContactPrefix(true);
    await update({
      column: "copyContactPrefix",
      data: value
    });
    setLoadingCopyContactPrefix(false);
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column: "chatBotType",
      data: value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column: "lgpdMessage",
      data: value
    });
    setLoadingLGPDMessage(false);
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({
      column: "transferMessage",
      data: value
    });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({
      column: "greetingAcceptedMessage",
      data: value
    });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setAcceptCallWhatsappMessage(value);
    setLoadingAcceptCallWhatsappMessage(true);
    await update({
      column: "AcceptCallWhatsappMessage",
      data: value
    });
    setLoadingAcceptCallWhatsappMessage(false);
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({
      column: "sendQueuePositionMessage",
      data: value
    });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({
      column: "showNotificationPending",
      data: value
    });
    setLoadingShowNotificationPending(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column: "lgpdLink",
      data: value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column: "lgpdDeleteMessage",
      data: value
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column: "lgpdConsent",
      data: value
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column: "lgpdHideNumber",
      data: value
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column: "sendGreetingAccepted",
      data: value
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column: "userRandom",
      data: value
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column: "sendMsgTransfTicket",
      data: value
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({
      column: "acceptCallWhatsapp",
      data: value
    });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column: "sendSignMessage",
      data: value
    });
    localStorage.setItem("sendSignMessage", value === "enabled" ? true : false); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column: "sendGreetingMessageOneQueues",
      data: value
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column: "sendQueuePosition",
      data: value
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column: "sendFarewellWaitingTicket",
      data: value
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({
      column: "acceptAudioMessageContact",
      data: value
    });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column: "enableLGPD",
      data: value
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data: value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({
      column: "closeTicketOnTransfer",
      data: value,
    });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleTransferredTicketStatus(value) {
    setTransferredTicketStatus(value);
    setLoadingTransferredTicketStatus(true);
    await update({
      column: "transferredTicketStatus",
      data: value,
    });
    setLoadingTransferredTicketStatus(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({
      column: "DirectTicketsToWallets",
      data: value,
    });
    setLoadingDirectTicketsToWallets(false);
  }

  async function handleChangeWavoipUrl(value) {
    setWavoipUrl(value);
    setLoadingWavoipUrl(true);
    await update({
      column: "wavoipUrl",
      data: value,
    });
    setLoadingWavoipUrl(false);
    toast.success("URL Wavoip atualizada com sucesso!");
  }

  async function handleChangeWavoipUsername(value) {
    setWavoipUsername(value);
    setLoadingWavoipUsername(true);
    await update({
      column: "wavoipUsername",
      data: value,
    });
    setLoadingWavoipUsername(false);
    toast.success("Usuário Wavoip atualizado com sucesso!");
  }

  async function handleChangeWavoipPassword(value) {
    setWavoipPassword(value);
    setLoadingWavoipPassword(true);
    await update({
      column: "wavoipPassword",
      data: value,
    });
    setLoadingWavoipPassword(false);
    toast.success("Senha Wavoip atualizada com sucesso!");
  }

  return (
    <>
      <Grid spacing={3} container>

        {/* AVALIAÇÕES */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.evaluations")}
            </span>
            <Switch
              checked={userRating === "enabled"}
              onChange={async (e) => {
                handleChangeUserRating(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingUserRating}
              color="primary"
            />
          </div>
        </Grid>

        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.sendGreetingAccepted")}
            </span>
            <Switch
              checked={SendGreetingAccepted === "enabled"}
              onChange={async (e) => {
                handleSendGreetingAccepted(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingSendGreetingAccepted}
              color="primary"
            />
          </div>
        </Grid>

        {/* ESCOLHER OPERADOR ALEATORIO */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.userRandom")}
            </span>
            <Switch
              checked={UserRandom === "enabled"}
              onChange={async (e) => {
                handleUserRandom(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingUserRandom}
              color="primary"
            />
          </div>
        </Grid>

        {/* ENVIAR MENSAGEM DE TRANSFERENCIA DE SETOR/ATENDENTE */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.sendMsgTransfTicket")}
            </span>
            <Switch
              checked={SettingsTransfTicket === "enabled"}
              onChange={async (e) => {
                handleSettingsTransfTicket(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingSettingsTransfTicket}
              color="primary"
            />
          </div>
        </Grid>

        {/* TIPO DO BOT */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <FormControl className={classes.selectContainer} fullWidth>
            <InputLabel id="chatBotType-label" shrink style={{ color: "#1a1a1a", fontWeight: 600 }}>
              Tipo do Bot
            </InputLabel>
            <Select
              labelId="chatBotType-label"
              id="chatBotType-select"
              value={chatBotType}
              label="Tipo do Bot"
              onChange={async (e) => {
                handleChatBotType(e.target.value);
              }}
              disabled={loadingScheduleType}
              style={{
                background: "#fafbfc",
                borderRadius: "8px",
                border: "1px solid #e8ecf1",
              }}
            >
              <MenuItem value="">Desabilitado</MenuItem>
              <MenuItem value="text">Texto</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* AVISO SOBRE LIGAÇÃO DO WHATSAPP */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.acceptCallWhatsapp")}
            </span>
            <Switch
              checked={AcceptCallWhatsapp === "enabled"}
              onChange={async (e) => {
                handleAcceptCallWhatsapp(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingAcceptCallWhatsapp}
              color="primary"
            />
          </div>
        </Grid>

        {/* HABILITAR PARA O ATENDENTE RETIRAR O ASSINATURA */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.sendSignMessage")}
            </span>
            <Switch
              checked={sendSignMessage === "enabled"}
              onChange={async (e) => {
                handleSendSignMessage(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingSendSignMessage}
              color="primary"
            />
          </div>
        </Grid>

        {/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
            </span>
            <Switch
              checked={sendGreetingMessageOneQueues === "enabled"}
              onChange={async (e) => {
                handleSendGreetingMessageOneQueues(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingSendGreetingMessageOneQueues}
              color="primary"
            />
          </div>
        </Grid>

        {/* AGENDAMENTO DE EXPEDIENTE */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <FormControl className={classes.selectContainer} fullWidth>
            <InputLabel id="scheduleType-label" style={{ color: "#1a1a1a", fontWeight: 600 }}>
              Agendamento de Expediente
            </InputLabel>
            <Select
              labelId="scheduleType-label"
              id="scheduleType-select"
              value={scheduleType}
              label="Agendamento de Expediente"
              onChange={async (e) => {
                handleScheduleType(e.target.value);
              }}
              disabled={loadingScheduleType}
              style={{
                background: "#fafbfc",
                borderRadius: "8px",
                border: "1px solid #e8ecf1",
              }}
            >
              <MenuItem value={"disabled"}>Desabilitado</MenuItem>
              <MenuItem value={"queue"}>Gerenciamento por Fila</MenuItem>
              <MenuItem value={"company"}>Gerenciamento por Empresa</MenuItem>
              <MenuItem value={"connection"}>Gerenciamento por Conexão</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM COM A POSIÇÃO DA FILA */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.sendQueuePosition")}
            </span>
            <Switch
              checked={sendQueuePosition === "enabled"}
              onChange={async (e) => {
                handleSendQueuePosition(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingSendQueuePosition}
              color="primary"
            />
          </div>
        </Grid>

        {/* ENVIAR MENSAGEM DE DESPEDIDA NO AGUARDANDO */}
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
            </span>
            <Switch
              checked={sendFarewellWaitingTicket === "enabled"}
              onChange={async (e) => {
                handleSendFarewellWaitingTicket(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingSendFarewellWaitingTicket}
              color="primary"
            />
          </div>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.acceptAudioMessageContact")}
            </span>
            <Switch
              checked={acceptAudioMessageContact === "enabled"}
              onChange={async (e) => {
                handleAcceptAudioMessageContact(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingAcceptAudioMessageContact}
              color="primary"
            />
          </div>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.enableLGPD")}
            </span>
            <Switch
              checked={enableLGPD === "enabled"}
              onChange={async (e) => {
                handleEnableLGPD(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingEnableLGPD}
              color="primary"
            />
          </div>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.requiredTag")}
            </span>
            <Switch
              checked={requiredTag === "enabled"}
              onChange={async (e) => {
                handleRequiredTag(e.target.checked ? "enabled" : "disabled");
              }}
              disabled={loadingRequiredTag}
              color="primary"
            />
          </div>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.closeTicketOnTransfer")}
            </span>
            <Switch
              checked={closeTicketOnTransfer === true}
              onChange={async (e) => {
                handleCloseTicketOnTransfer(e.target.checked);
              }}
              disabled={loadingCloseTicketOnTransfer}
              color="primary"
            />
          </div>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={4} item>
          <FormControl className={classes.selectContainer} fullWidth>
            <InputLabel id="transferredTicketStatus-label" style={{ color: "#1a1a1a", fontWeight: 600 }}>
              {i18n.t("settings.settings.options.transferredTicketStatus")}
            </InputLabel>
            <Select
              labelId="transferredTicketStatus-label"
              value={transferredTicketStatus}
              onChange={async (e) => {
                handleTransferredTicketStatus(e.target.value);
              }}
              disabled={loadingTransferredTicketStatus}
              style={{
                background: "#fafbfc",
                borderRadius: "8px",
                border: "1px solid #e8ecf1",
              }}
            >
              <MenuItem value={"open"}>{i18n.t("settings.settings.options.open")}</MenuItem>
              <MenuItem value={"pending"}>{i18n.t("settings.settings.options.pending")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingTransferredTicketStatus && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.showNotificationPending")}
            </span>
            <Switch
              checked={showNotificationPending === true}
              onChange={async (e) => {
                handleShowNotificationPending(e.target.checked);
              }}
              disabled={loadingShowNotificationPending}
              color="primary"
            />
          </div>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={4} item>
          <div className={classes.toggleContainer}>
            <span className={classes.toggleLabel}>
              {i18n.t("settings.settings.options.DirectTicketsToWallets")}
            </span>
            <Switch
              checked={directTicketsToWallets === true}
              onChange={async (e) => {
                handleDirectTicketsToWallets(e.target.checked);
              }}
              disabled={loadingDirectTicketsToWallets}
              color="primary"
            />
          </div>
        </Grid>
      </Grid>
      <br></br>


      {/* CONFIGURAÇÃO SIGLA PARA CÓPIA DE CONTATOS */}
      <Grid spacing={3} container>
        <Accordion style={{ width: "100%", marginTop: 20, marginBottom: 20 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <span style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a" }}>Configuração de Sigla para Cópia de Contato</span>
          </AccordionSummary>
          <AccordionDetails>
            <Grid spacing={3} container style={{ width: "100%" }}>
              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="copyContactPrefix"
                    name="copyContactPrefix"
                    margin="dense"
                    label={i18n.t("settings.settings.options.copyContactPrefix")}
                    variant="outlined"
                    value={copyContactPrefix}
                    placeholder={i18n.t("settings.settings.options.copyContactPrefixPlaceholder")}
                    onChange={async (e) => {
                      handleCopyContactPrefix(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <FormHelperText>
                    {loadingCopyContactPrefix && i18n.t("settings.settings.options.updating")}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>

      
      {/*-----------------LGPD-----------------*/}
      {enableLGPD === "enabled" && (
        <>
          <Grid spacing={3} container
            style={{ marginBottom: 10 }}>
            <Tabs
              value={0}
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="on"
              variant="scrollable"
              className={classes.tab}
            >
              <Tab

                label={i18n.t("settings.settings.LGPD.title")} />

            </Tabs>
          </Grid>
          <Grid spacing={1} container>
            <Grid xs={12} sm={6} md={12} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdMessage"
                  name="lgpdMessage"
                  margin="dense"
                  multiline
                  rows={3}
                  label={i18n.t("settings.settings.LGPD.welcome")}
                  variant="outlined"
                  value={lgpdMessage}
                  onChange={async (e) => {
                    handleLGPDMessage(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadinglgpdMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} md={12} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdLink"
                  name="lgpdLink"
                  margin="dense"
                  label={i18n.t("settings.settings.LGPD.linkLGPD")}
                  variant="outlined"
                  value={lgpdLink}
                  onChange={async (e) => {
                    handleLGPDLink(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadingLGPDLink && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Manter ou nao mensagem deletada pelo contato */}
            <Grid xs={12} sm={6} md={4} item>
              <div className={classes.toggleContainer}>
                <span className={classes.toggleLabel}>
                  {i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}
                </span>
                <Switch
                  checked={lgpdDeleteMessage === "enabled"}
                  onChange={async (e) => {
                    handleLGPDDeleteMessage(e.target.checked ? "enabled" : "disabled");
                  }}
                  disabled={loadingLGPDDeleteMessage}
                  color="primary"
                />
              </div>
            </Grid>
            {/* LGPD Sempre solicitar confirmaçao / conscentimento dos dados */}
            <Grid xs={12} sm={6} md={4} item>
              <div className={classes.toggleContainer}>
                <span className={classes.toggleLabel}>
                  {i18n.t("settings.settings.LGPD.alwaysConsent")}
                </span>
                <Switch
                  checked={lgpdConsent === "enabled"}
                  onChange={async (e) => {
                    handleLGPDConsent(e.target.checked ? "enabled" : "disabled");
                  }}
                  disabled={loadingLGPDConsent}
                  color="primary"
                />
              </div>
            </Grid>
            {/* LGPD Ofuscar número telefone para usuários */}
            <Grid xs={12} sm={6} md={4} item>
              <div className={classes.toggleContainer}>
                <span className={classes.toggleLabel}>
                  {i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
                </span>
                <Switch
                  checked={lgpdHideNumber === "enabled"}
                  onChange={async (e) => {
                    handleLGPDHideNumber(e.target.checked ? "enabled" : "disabled");
                  }}
                  disabled={loadingLGPDHideNumber}
                  color="primary"
                />
              </div>
            </Grid>
          </Grid>
        </>
      )}

      <Grid spacing={3} container>
        {/* Seção de Recebimentos de Faturas movida para Central de Apps */}
        {false && isSuper() ?
          <Accordion style={{ width: "100%", marginTop: 20, marginBottom: 20 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <span style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a" }}>Recebimentos de Faturas</span>
            </AccordionSummary>
            <AccordionDetails>
              <Grid spacing={3} container style={{ width: "100%" }}>
                <Grid xs={12} sm={12} md={12} item>
                  <FormControl className={classes.selectContainer}>
                    <TextField
                      id='mpaccesstoken'
                      name='mpaccesstoken'
                      margin='dense'
                      label='Access Token Mercado Pago'
                      variant='outlined'
                      value={mpaccesstokenType}
                      onChange={async (e) => {
                        handleChangempaccesstoken(e.target.value);
                      }}
                    ></TextField>
                    <FormHelperText>
                      {loadingmpaccesstokenType && 'Atualizando...'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid xs={12} sm={12} md={12} item>
                  <FormControl className={classes.selectContainer}>
                    <TextField
                      id='asaastoken'
                      name='asaastoken'
                      margin='dense'
                      label='Token ASAAS'
                      variant='outlined'
                      value={asaastokenType}
                      onChange={async (e) => {
                        handleChangeasaastoken(e.target.value);
                      }}
                    ></TextField>
                    <FormHelperText>
                      {loadingasaastokenType && 'Atualizando...'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          : null}
      </Grid>

      {/* WAVOIP Configuration - Movido para Central de Apps */}
      {false && (
      <Grid spacing={3} container>
        <Accordion style={{ width: "100%", marginTop: 20, marginBottom: 20 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <span style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a" }}>Wavoip</span>
          </AccordionSummary>
          <AccordionDetails>
            <Grid spacing={3} container style={{ width: "100%" }}>
              <Grid xs={12} sm={12} md={12} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id='wavoipUrl'
                    name='wavoipUrl'
                    margin='dense'
                    label='URL Wavoip (ex: https://api.wavoip.com)'
                    variant='outlined'
                    value={wavoipUrl}
                    onChange={async (e) => {
                      handleChangeWavoipUrl(e.target.value);
                    }}
                    placeholder='https://api.wavoip.com'
                  ></TextField>
                  <FormHelperText>
                    {loadingWavoipUrl && 'Atualizando...'}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id='wavoipUsername'
                    name='wavoipUsername'
                    margin='dense'
                    label='Email/Usuário Wavoip'
                    variant='outlined'
                    value={wavoipUsername}
                    onChange={async (e) => {
                      handleChangeWavoipUsername(e.target.value);
                    }}
                    type='email'
                  ></TextField>
                  <FormHelperText>
                    {loadingWavoipUsername && 'Atualizando...'}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id='wavoipPassword'
                    name='wavoipPassword'
                    margin='dense'
                    label='Senha Wavoip'
                    variant='outlined'
                    type='password'
                    value={wavoipPassword}
                    onChange={async (e) => {
                      handleChangeWavoipPassword(e.target.value);
                    }}
                  ></TextField>
                  <FormHelperText>
                    {loadingWavoipPassword && 'Atualizando...'}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      )}

      {/* MENSAGENS CUSTOMIZADAS */}
      <Grid spacing={3} container>
        <Accordion style={{ width: "100%", marginTop: 20, marginBottom: 20 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <span style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a" }}>Mensagens Customizadas</span>
          </AccordionSummary>
          <AccordionDetails>
            <Grid spacing={1} container style={{ width: "100%" }}>
              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="transferMessage"
                    name="transferMessage"
                    margin="dense"
                    multiline
                    rows={3}
                    label="Mensagem de transferência - ${queue.name} = fila destino"
                    variant="outlined"
                    value={transferMessage}
                    required={SettingsTransfTicket === "enabled"}
                    onChange={async (e) => {
                      handletransferMessage(e.target.value);
                    }}
                  >
                  </TextField>
                  <FormHelperText>
                    {loadingTransferMessage && i18n.t("settings.settings.options.updating")}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="greetingAcceptedMessage"
                    name="greetingAcceptedMessage"
                    margin="dense"
                    multiline
                    rows={3}
                    label="Mensagem de Saudação ao aceitar ticket"
                    variant="outlined"
                    value={greetingAcceptedMessage}
                    required={SendGreetingAccepted === "enabled"}
                    onChange={async (e) => {
                      handleGreetingAcceptedMessage(e.target.value);
                    }}
                  >
                  </TextField>
                  <FormHelperText>
                    {loadingGreetingAcceptedMessage && i18n.t("settings.settings.options.updating")}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="AcceptCallWhatsappMessage"
                    name="AcceptCallWhatsappMessage"
                    margin="dense"
                    multiline
                    rows={3}
                    label="Mensagem para informar que não aceita ligações"
                    variant="outlined"
                    required={AcceptCallWhatsapp === "disabled"}
                    value={AcceptCallWhatsappMessage}
                    onChange={async (e) => {
                      handleAcceptCallWhatsappMessage(e.target.value);
                    }}
                  >
                  </TextField>
                  <FormHelperText>
                    {loadingAcceptCallWhatsappMessage && i18n.t("settings.settings.options.updating")}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid xs={12} sm={6} md={6} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="sendQueuePositionMessage"
                    name="sendQueuePositionMessage"
                    margin="dense"
                    multiline
                    required={sendQueuePosition === "enabled"}
                    rows={3}
                    label="Mensagem de posição na fila"
                    variant="outlined"
                    value={sendQueuePositionMessage}
                    onChange={async (e) => {
                      handlesendQueuePositionMessage(e.target.value);
                    }}
                  >
                  </TextField>
                  <FormHelperText>
                    {loadingSendQueuePositionMessage && i18n.t("settings.settings.options.updating")}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
